import Header from './components/Header';
import About from './components/About';
import PortfolioProject from './components/PortfolioProject';
import styled from 'styled-components';


const ProjectsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;

  @media (max-width: 1500px) {
  height:auto;
  width:auto;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    padding: 20px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 80%;
  text-align: center; 

  @media (max-width: 768px) {
    max-width: 90%;
    padding: 10px;
  }

  @media (max-width: 480px) {
    max-width: 95%;
    padding: 5px;
  }
`;


function App() {
  return (
    <PageWrapper>
      <ContentWrapper>
        <div className="App">
          <Header />
          <About />
          <ProjectsGrid>
            <PortfolioProject
              title="egg-cellent"
              image="/images/portfolioproject-eggcellent.png"
              description="A recipe-sharing web app with full CRUD functionality and user authentication, built with Django REST Framework and React."
              link="https://cooking-app-demo-35a074f514f1.herokuapp.com/"
              sourceCode="https://github.com/kyunghei/cooking-app" />
            <PortfolioProject
              title="MyMaplestory"
              image="/images/portfolioproject-mymaplestory.png"
              description="A static web application built using HTML, CSS, and JavaScript with jQuery for dynamic interactions."
              link="https://mymaplestory.netlify.app/"
              sourceCode="https://github.com/kyunghei/my-maplestory" />
            <PortfolioProject
              title="Tokopi Playground"
              image="/images/portfolioproject-tokopiplayground.png"
              description="A database-driven web application built with MySQL, Node.js, Express, and EJS handlebars to manage data for a fictional doggy daycare business."
              link="https://young-oasis-98041-180088b20db6.herokuapp.com/"
              sourceCode="https://github.com/kyunghei/TokopiPlayground" />
            <PortfolioProject
              title="Timeless Tales"
              image="/images/portfolioproject-timelesstales.png"
              description="An interactive storytelling web app that uses OpenAI's GPT API to dynamically generate story text and images. This was developed by a collaborative team using React and Python."
              link=""
              sourceCode="https://github.com/kyunghei/Timeless-Tales" />
          </ProjectsGrid>
        </div>
      </ContentWrapper>
    </PageWrapper>

  );
}

export default App;
